export default __webpack_public_path__ + "assets/images/getting-a-quote-1ce508807783b193725538f82e62ec17.png";